document.addEventListener("DOMContentLoaded", function () {
  const track = document.getElementById("bundleCarouselTrack");
  const dots = document.querySelectorAll(".bundle-dot");
  const slides = document.querySelectorAll(".bundle-carousel-slide");
  let index = 0;

  function goToSlide(i) {
    track.scrollTo({
      left: slides[i].offsetLeft,
      behavior: "smooth",
    });
    dots.forEach((dot) => dot.classList.remove("bundle-active"));
    dots[i].classList.add("bundle-active");
    index = i;
  }

  dots.forEach((dot) => {
    dot.addEventListener("click", () => {
      goToSlide(parseInt(dot.dataset.index));
      resetInterval();
    });
  });

  function nextSlide() {
    index = (index + 1) % slides.length;
    goToSlide(index);
  }

  let interval = setInterval(nextSlide, 4000);

  function resetInterval() {
    clearInterval(interval);
    interval = setInterval(nextSlide, 4000);
  }
});
